module.exports = __webpack_public_path__ + "media/images/project/milestone-bcb6960188d71af58d1ce53c0f689e5a.svg";